import React, { Fragment, memo } from 'react';
import PropTypes from 'prop-types';
import { FaMinus, FaPlus } from 'react-icons/fa';
import clsx from 'clsx';

const RangeSetting = ({
  onIncrement,
  onDecrement,
  lowWidth,
  value,
  type,
  label,
  helperText,
}) => {
  const handleIncrementValue = () => {
    onIncrement(type);
  };

  const handleDecrementValue = () => {
    onDecrement(type);
  };

  const classNames = {
    buttonClass: clsx(
      'inline-block border border-theme text-theme rounded-xl focus:outline-none hover:bg-theme hover:text-white',
      lowWidth ? 'text-xs p-1' : 'h-8 w-8 p-2',
    ),
    labelClass: clsx(
      lowWidth ? 'px-1 whitespace-no-wrap' : 'font-bold',
    ),
    valueClass: clsx(
      'inline-block align-top font-bold',
      lowWidth ? 'px-1 py-0 text-center' : 'py-2 px-4 ',
    ),
    textClass: clsx(
      'text-left',
      lowWidth ? 'col-span-5' : 'col-span-2',
    ),
  };

  return (
    <>
      <div className={classNames.textClass}>
        <div className={classNames.labelClass}>{label}</div>
        {
          helperText && (
            <div className="text-xs text-gray-600">{helperText}</div>
          )
        }
      </div>
      <div className=" ml-1 text-right flex items-center justify-between">
        {onDecrement && (
          <button
            type="button"
            className={classNames.buttonClass}
            onClick={handleDecrementValue}
          >
            <FaMinus className="m-auto" />
          </button>
        )}
        <div className={classNames.valueClass} style={{ minWidth: lowWidth && '27px' }}>
          {value}
        </div>
        {onIncrement && (
          <button
            type="button"
            className={classNames.buttonClass}
            onClick={handleIncrementValue}
          >
            <FaPlus className="m-auto" />
          </button>
        )}
      </div>
    </>
  );
};

RangeSetting.defaultProps = {
  lowWidth: false,
  helperText: '',
};

RangeSetting.propTypes = {
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]).isRequired,
  type: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  helperText: PropTypes.string,
  onIncrement: PropTypes.func,
  onDecrement: PropTypes.func,
  lowWidth: PropTypes.bool,
};

RangeSetting.defaultProps = {
  onIncrement: undefined,
  onDecrement: undefined,
};
export default memo(RangeSetting);
